// extracted by mini-css-extract-plugin
export default {"closeWrap":"close-button_closeWrap__1q3l1","closeWrapLeft":"close-button_closeWrapLeft__vP1kM","closeBtnRight":"close-button_closeBtnRight__isyxU"};